'use client'
import { SbBlokData, storyblokEditable, StoryblokServerComponent } from '@storyblok/react/rsc'
import { FC, useEffect, useState } from 'react'

// import { PhnxImageHolder } from '../ImageHolder/ImageHolder'
import { AssetField } from '@/lib/asset'
import { stylePanelSBData } from '@/lib/stylePanel'

import { PhnxImageHolder } from '../ImageHolder/ImageHolder'
import { PhnxTextBlock } from './TextBlock'
import { TextAreaProps } from './TextBlock'

export type Donation = {
  amount: string
  dataID: string
  prodProductID?: string
  testProductID?: string
}

interface TextBlokProps {
  blok: {
    title?: TextAreaProps['title']
    postTitle?: TextAreaProps['heading']
    content?: SbBlokData[]
    padding?: SbBlokData[]
    layout?: TextAreaProps['layout']
    background?: SbBlokData[]
    colour?: SbBlokData[]
    alignment?: SbBlokData[]
    feature?: boolean
    donationitems?: any[]
    donationstitle?: TextAreaProps['donationstitle']
    donationsdescription?: SbBlokData[]
    donationsterms?: TextAreaProps['donationsterms']
    donationsasset?: AssetField
    id: any
    featureVariant?: TextAreaProps['featureVariant']
  } & SbBlokData
}

const TextBlok: FC<TextBlokProps> = ({ blok }) => {
  let stylePanel = stylePanelSBData(blok.colour, blok.background, blok.alignment, blok.padding)
  // TODO here we have to get stripe code
  const [donationsData, setDonationData] = useState<Donation[]>([])
  useEffect(() => {
    if (blok.donationitems && blok.donationitems.length > 0) {
      const donations = blok.donationitems.map((item: any) => ({
        amount: item.amount,
        dataID: item.link.cached_url,
        prodProductID: item.prodProductID,
        testProductID: item.testProductID,
      }))

      setDonationData(donations)
    }
  }, [blok.donations])

  return (
    <div {...storyblokEditable(blok)} id={blok.id}>
      <PhnxTextBlock
        title={blok.title}
        heading={blok.postTitle ? (blok.postTitle as string) : ''}
        textColor={stylePanel.textColor}
        paragraph={
          blok.content &&
          blok.content.map((nestedBlok: SbBlokData) => (
            <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} />
          ))
        }
        layout={blok.layout as 'default' | 'compact'}
        backgroundColor={stylePanel.backgroundColor}
        padding={stylePanel.padding}
        alignment={stylePanel.alignment as 'left' | 'center' | 'right'}
        feature={blok.feature}
        featureVariant={blok.featureVariant ? blok.featureVariant : 'primary'}
        donations={donationsData}
        donationstitle={blok.donationstitle}
        donationsdescription={
          blok.donationsdescription &&
          blok.donationsdescription.length > 0 &&
          blok.donationsdescription.map((nestedBlok: SbBlokData) => (
            <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} />
          ))
        }
        donationsasset={
          blok.donationsasset ? (
            <PhnxImageHolder
              images={[
                {
                  src: blok.donationsasset.filename ? blok.donationsasset.filename : '',
                  alt: blok.donationsasset.alt ? blok.donationsasset.alt : '',
                  focus: blok.donationsasset.focus ? blok.donationsasset.focus : '',
                },
              ]}
            />
          ) : null
        }
      />
    </div>
  )
}

export default TextBlok
